import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/service-system`

export default {
  options: payload => Client.get(`${resource}/type/option`, {
    params: payload,
  }),
}
